import { render, staticRenderFns } from "./EmploymentDocuments.vue?vue&type=template&id=1b1a4bf0"
import script from "./EmploymentDocuments.vue?vue&type=script&lang=js"
export * from "./EmploymentDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports